import React from "react";
import "./i18n";
import ReactDOM from "react-dom/client";
import App from "@/App";
import "@/index.css";
import "@/styles/grapesjs-light.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
